import MyobCompanyFileHtml from './myob.company-file.html';

export function MYOBSettingsCtrl (
  $q,
  $rootScope,
  $scope,
  $state,
  $translate,
  $uibModal,
  $window,
  accountingSettings,
  API,
  company_settings,
  confirm,
  messages,
  myobApi,
  sessionObjAPI,
  settings,
  workshopAPI
  ) {
  $scope.accountingSettings = accountingSettings;
  $scope.loaded             = true;
  $scope.myob_settings      = company_settings;
  $scope.settings           = settings;

  $scope.authorize = function () {
    $q.when()
    .then(() => $rootScope.Company.confirmAccountingIntegration())
    .then(() => $rootScope.Company.isLinkedToBranch() && !$rootScope.Company.isSharedAccounting() ?
      $rootScope.Company.shareAccounting('myob')
      .finally(() => myobApi.checkExistingIntegrations()) :
      myobApi.checkExistingIntegrations()
    )
    .then(response => response === 'true' ?
      confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.CONFIRM_INTEGRATION', { name: 'MYOB' }))
      .catch(() => confirm.textConfirm($translate.instant('JS_SPACE.INTEGRATIONS.CLEAR_ID_STATEMENT'), $translate.instant('JS_SPACE.INTEGRATIONS.CLEAR_IDS')))
      .then(() => myobApi.clearID()) :
      $q.when(true)
    )
    .then(() => {
      if (sessionObjAPI.company().has_xero) {
        return $q.reject($translate.instant('JS_SPACE.INTEGRATIONS.ACCOUNTING_UNAUTH_FIRST', {
          name1: 'MYOB',
          name2: 'Xero'
        }));
      } else if ($rootScope.Company.hasIntegration('quickbooks')) {
        return $q.reject($translate.instant('JS_SPACE.INTEGRATIONS.ACCOUNTING_UNAUTH_FIRST', {
          name1: 'MYOB',
          name2: $translate.instant('COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS_ONLINE')
        }));
      }

      return $q.when(true);
    })
    .then(() => {
      $window.location.assign(`${API.url}/myob/new`);
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.chooseCompanyFile = function () {
    $uibModal.open({
      controller : 'MYOBCompanyFileCtrl',
      templateUrl: MyobCompanyFileHtml,
      windowClass: 'md-modal flip-container',
      resolve    : {
        settings: () => $scope.settings
      }
    }).result
    .then(company => {
      $scope.settings.myob_company_file_id   = company.Id;
      $scope.settings.myob_company_file_name = company.Name;

      workshopAPI.patch('/company', $scope.settings, 'company')
      .then(() => {
        $state.reload();
      })
      .catch(err => {
        messages.error(err);
      });
    })
    .catch(() => {
      if ($scope.settings.has_myob && $scope.settings.needs_myob_company_file_auth) {
        $state.go('app');
      }
    });
  };

  $scope.getOptions = function () {
    $scope.loading = true;

    $q.all({
      accounts : workshopAPI.get('/myob/accounts'),
      rates    : workshopAPI.get('/myob/tax_rates'),
      zeroTaxes: workshopAPI.get('myob/zero_tax')
    })
    .then(data => {
      $scope.expenseAccounts = data.accounts.expense_accounts;
      $scope.incomeAccounts  = data.accounts.income_accounts;
      $scope.bankAccounts    = data.accounts.bank_accounts;
      $scope.allAccounts     = data.accounts.all_accounts;

      $scope.salesTaxRates     = angular.copy(data.rates.tax_rates);
      $scope.purchasesTaxRates = angular.copy(data.rates.tax_rates);
      $scope.roundingTaxRates  = angular.copy(data.rates.tax_rates);

      $scope.zeroTaxes = data.zeroTaxes.tax_rates;

      var matchingSales     = $scope.salesTaxRates.filter(rate => rate.UID === $scope.settings.myob_sales_tax_id);
      var matchingPurchases = $scope.purchasesTaxRates.filter(rate => rate.UID === $scope.settings.myob_purchases_tax_id);
      var matchingRounding  = $scope.roundingTaxRates.filter(rate => rate.UID === $scope.settings.myob_rounding_tax_id);

      $scope.salesTax     = matchingSales[0] || {};
      $scope.purchasesTax = matchingPurchases[0] || {};
      $scope.roundingTax  = matchingRounding[0] || {};

      $scope.setSalesTax($scope.salesTax);
      $scope.setPurchasesTax($scope.purchasesTax);
      $scope.setRoundingTax($scope.roundingTax);
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() =>{
      $scope.loading = false;
    });
  };

  $scope.save = function () {
    $scope.validate()
    .then(() => $rootScope.Company.saveAccountingSettings($scope.accountingSettings))
    .then(() => workshopAPI.patch('/company', $scope.settings, 'company'))
    .then(settings => workshopAPI.patch('/company_settings', $scope.myob_settings, 'company_setting'))
    .then(company_settings => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.saveAccountingSettings = function (form) {
    $rootScope.Company.saveAccountingSettings($scope.accountingSettings)
    .then(result => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $scope.saving = false;
    });
  };

  $scope.setMYOBSharesAccount = function () {
    myobApi.shareAccount(settings.shares_accounting)
    .then(response => {
      if (response) {
        messages.show('Shares Accounting setting successfully changed');
        $state.reload();
      }
    })
    .catch(err => {
      //reverts the toggle value to its original value before the call since it was returned as an error
      settings.shares_accounting = !settings.shares_accounting;

      messages.error(err);
    });
  };

  $scope.setPurchaseAccounts = function () {
    $scope.accountingSettings.myob_accessories_purchases_account = $scope.accountingSettings.use_product_for_purchase_account ? $scope.settings.myob_vendor_invoice_account : '';
    $scope.accountingSettings.myob_consumable_purchases_account  = $scope.accountingSettings.use_product_for_purchase_account ? $scope.settings.myob_vendor_invoice_account : '';
    $scope.accountingSettings.myob_labor_purchases_account       = $scope.accountingSettings.use_product_for_purchase_account ? $scope.settings.myob_vendor_invoice_account : '';
    $scope.accountingSettings.myob_stock_purchases_account       = $scope.accountingSettings.use_product_for_purchase_account ? $scope.settings.myob_vendor_invoice_account : '';
    $scope.accountingSettings.myob_sublet_purchases_account      = $scope.accountingSettings.use_product_for_purchase_account ? $scope.settings.myob_vendor_invoice_account : '';
    $scope.accountingSettings.myob_tires_purchases_account       = $scope.accountingSettings.use_product_for_purchase_account ? $scope.settings.myob_vendor_invoice_account : '';
  };

  $scope.setPurchasesTax = function (tax) {
    $scope.purchasesTaxRate               = tax.Rate;
    $scope.settings.myob_purchases_tax_id = tax.UID;
  };

  $scope.setRoundingTax = function (tax) {
    $scope.roundingTaxRate               = tax.Rate;
    $scope.settings.myob_rounding_tax_id = tax.UID;
  };

  $scope.setSalesTax = function (tax) {
    $scope.salesTaxRate               = tax.Rate;
    $scope.settings.myob_sales_tax_id = tax.UID;
  };

  $scope.toggleInventoryActions = function () {
    $scope.myob_settings.myob_untick_inventory_item = !$scope.settings.myob_inventory_vendor_products;
    $scope.settings.myob_inventory_vendor_account   = $scope.settings.myob_inventory_vendor_products
      ? $scope.settings.myob_inventory_vendor_account
      : null;
  };

  $scope.unauthorize = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.UNAUTHORISE', { name: 'MYOB' }))
    .then(() => workshopAPI.get('/company/remove_myob'))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.UNAUTHORISED', { name: 'MYOB' }), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.validate = function () {
    const roundingTaxRate = new BigDecimal($scope.roundingTaxRate ? $scope.roundingTaxRate.toString(): '0');

    return $scope.settings.myob_rounding_account && !roundingTaxRate.isZero() ?
      $q.reject($translate.instant('JS_SPACE.MYOB.ROUNDING_TAX_MUST_BE_ZERO')) :
      $q.when(true);
  };

  if ($scope.settings.has_myob && $scope.settings.needs_myob_company_file_auth) {
    $scope.chooseCompanyFile();
  }
  else if ($scope.settings.has_myob && !$scope.settings.needs_myob_company_file_auth && $scope.needs_myob_setup) {
    $scope.needsSetup = true;
  }
  if ($scope.settings.has_myob && !$scope.settings.needs_myob_company_file_auth) {
    $scope.getOptions();
  }
};
